module.exports = __webpack_public_path__ + "static/logo-square-2-29be750cd7c9edba8179821f36ea58c9.jpg";